import React, { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Navbar from './components/common/Navbar';
import LoginModal from './components/Modal/LoginModal';
import { onAuthStateChanged } from '@firebase/auth';
import { auth } from './config/firebase.config';
import { ToastContainer } from 'react-toastify';
import PrivateRoute from './components/Route/PrivateRoute';

const App = () => {
  const [loginModalIsOpen, setLoginModalIsOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const toggleLoginModal = () => {
    setLoginModalIsOpen(!loginModalIsOpen);
  }

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
        if(user) {
            setCurrentUser(user);
        }
        else {
            setCurrentUser(null);
        }
    })
}, [currentUser]);

  return (
    <React.Fragment>
      <Navbar toggleLoginModal={toggleLoginModal} currentUser={currentUser} />
      <ToastContainer />
      <main className='container mx-auto w-[90%]'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/dashboard' element={
            <PrivateRoute currentUser={currentUser}>
              <Dashboard />
            </PrivateRoute>
          } />
        </Routes>
      </main>
      <LoginModal
        loginModalIsOpen={loginModalIsOpen}
        toggleLoginModal={toggleLoginModal}
      />
    </React.Fragment>
  )
}

export default App